import { render, staticRenderFns } from "./index.vue?vue&type=template&id=c6c46f4e&scoped=true&"
import script from "./index.vue?vue&type=script&lang=js&"
export * from "./index.vue?vue&type=script&lang=js&"
import style0 from "./index.vue?vue&type=style&index=0&id=c6c46f4e&scoped=scoped&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c6c46f4e",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\work\\code\\aihuz\\arbitration-ui\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('c6c46f4e')) {
      api.createRecord('c6c46f4e', component.options)
    } else {
      api.reload('c6c46f4e', component.options)
    }
    module.hot.accept("./index.vue?vue&type=template&id=c6c46f4e&scoped=true&", function () {
      api.rerender('c6c46f4e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/trialSchedule/courtSchedule/index.vue"
export default component.exports